// @ts-nocheck

export enum LocationType {
  EXCHANGE = "EXCHANGE",
  INSITU = "INSITU",
  EXCHANGE_METERED = "EXCHANGE_METERED",
  INSITU_METERED = "INSITU_METERED",
  METERED = "METERED",
  TERMINAL = "TERMINAL",
}

export enum ProductType {
  EXCHANGE,
  INSITU,
  METERED_NETWORK,
  SUNDRY_ONLY,
}

export interface IProduct {
  code: string;
  name?: string;
  type: ProductType;
}

export enum ValidationStatus {
  PASSED = "PASSED",
  FAILED = "FAILED",
}

export interface ILocationValidation {
  locationType?: LocationType;
  defaultProduct?: IProduct;
  cocRequired?: boolean;
  validationStatus?: ValidationStatus;
}
